module.exports = __webpack_public_path__ + "img/28_43.7f628fef.png";